module.exports = __webpack_public_path__ + "img/placeholder3.a59057c7.png";